/**
 * Helper para manejar la selección de terminales Bold
 */
export class BoldTerminalHelper {
    static STORAGE_KEY = "bold_selected_terminal";

    /**
     * Obtiene la terminal seleccionada desde localStorage
     * @returns {Object|null} Terminal seleccionada o null si no hay ninguna
     */
    static getSelectedTerminal() {
        try {
            const saved = localStorage.getItem(this.STORAGE_KEY);
            return saved ? JSON.parse(saved) : null;
        } catch (error) {
            console.error("Error al obtener terminal seleccionada:", error);
            return null;
        }
    }

    /**
     * Guarda una terminal como seleccionada
     * @param {Object} terminal - Objeto con los datos de la terminal
     * @param {string} terminal.terminal_serial - Serial de la terminal
     * @param {string} terminal.terminal_model - Modelo de la terminal
     */
    static setSelectedTerminal(terminal) {
        try {
            if (
                !terminal ||
                !terminal.terminal_serial ||
                !terminal.terminal_model
            ) {
                throw new Error("Terminal debe tener serial y model");
            }
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(terminal));
            return true;
        } catch (error) {
            console.error("Error al guardar terminal seleccionada:", error);
            return false;
        }
    }

    /**
     * Limpia la terminal seleccionada
     */
    static clearSelectedTerminal() {
        try {
            localStorage.removeItem(this.STORAGE_KEY);
            return true;
        } catch (error) {
            console.error("Error al limpiar terminal seleccionada:", error);
            return false;
        }
    }

    /**
     * Verifica si hay una terminal seleccionada
     * @returns {boolean}
     */
    static hasSelectedTerminal() {
        return this.getSelectedTerminal() !== null;
    }

    /**
     * Obtiene los datos de terminal para ser usados en pagos
     * Si no hay terminal seleccionada, retorna null
     * @returns {Object|null}
     */
    static getTerminalForPayment() {
        const terminal = this.getSelectedTerminal();
        if (!terminal) return null;

        return {
            terminal_model: terminal.terminal_model,
            terminal_serial: terminal.terminal_serial,
        };
    }

    /**
     * Valida que una terminal sea válida
     * @param {Object} terminal
     * @returns {boolean}
     */
    static isValidTerminal(terminal) {
        return (
            terminal &&
            typeof terminal.terminal_serial === "string" &&
            terminal.terminal_serial.trim() !== "" &&
            typeof terminal.terminal_model === "string" &&
            terminal.terminal_model.trim() !== ""
        );
    }

    /**
     * Obtiene información formateada de la terminal actual
     * @returns {string} Texto formateado como "Modelo - Serial" o mensaje por defecto
     */
    static getDisplayText() {
        const terminal = this.getSelectedTerminal();
        if (!terminal) return "No hay terminal seleccionada";

        return `${terminal.terminal_model} - ${terminal.terminal_serial}`;
    }
}

export default BoldTerminalHelper;